import { render, staticRenderFns } from "./BtnAtualizarItemRequisicao.vue?vue&type=template&id=23976abc"
import script from "./BtnAtualizarItemRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarItemRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports